// src/components/ui/ConfirmModal.jsx
// Использование:
//   <ConfirmModal
//     isOpen={showConfirm}
//     onClose={() => setShowConfirm(false)}
//     onConfirm={handleDelete}
//     title="Удалить админа?"
//     message="Это действие необратимо."
//   />

import React from 'react';
import { AlertTriangle, X } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Modal } from './Modal';
import { Button } from './Button';

export const ConfirmModal = ({
  isOpen = false,
  onClose,
  onConfirm,
  title,
  message,
  confirmLabel,
  cancelLabel,
}) => {
  const { t } = useTranslation();
  const resolvedTitle = title ?? t('ui_ConfirmModal.you_uvereny');
  const resolvedMessage = message ?? t('ui_ConfirmModal.this_active_irreversible');
  const resolvedConfirmLabel = confirmLabel ?? t('ui_ConfirmModal.delete');
  const resolvedCancelLabel = cancelLabel ?? t('ui_ConfirmModal.cancel');

  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={null}>
      <div className="flex items-start justify-between gap-2">
        <div className="inline-flex p-3 rounded-2xl bg-red-500/10 text-red-500">
          <AlertTriangle size={24} />
        </div>
        <Button variant="icon" onClick={onClose} className="flex-shrink-0">
          <X size={20} />
        </Button>
      </div>
      <div>
        <h3 className="font-black text-lg uppercase italic">{resolvedTitle}</h3>
        {resolvedMessage && <p className="text-gray-400 text-sm mt-2">{resolvedMessage}</p>}
      </div>
      <div className="flex gap-3">
        <Button variant="danger" onClick={handleConfirm} className="flex-1 rounded-2xl">
          {resolvedConfirmLabel}
        </Button>
        <Button variant="secondary" onClick={onClose} className="rounded-2xl">
          {resolvedCancelLabel}
        </Button>
      </div>
    </Modal>
  );
};
